/**
 * Created by Fatih on 18.08.2016.
 */

import $ from 'jquery';
import { replace, basePathname } from './store/history.js';

function setPageActive(bool) {
	const $aboutUsPage = $('.about-menu');
	$aboutUsPage.find('.icon-close').click(() => {
		replace(basePathname());
	});
	if (bool) {
		$aboutUsPage.addClass('menu--is-open');
		setTimeout(function () {
			$aboutUsPage.css('transform', 'initial');
			//this part is for smooth scrolling in iOS
			$('.tabs-container').addClass('u-dn');
			if (window.location.href.indexOf('shop') !== -1) {
				$('.pusher').children().each(function () {
					$(this).addClass('u-dn');
				});
			}
		}, 500);
	} else {
		$aboutUsPage.removeClass('menu--is-open');
		$aboutUsPage.removeAttr('style');
		//this part is for smooth scrolling in iOS
		$('.tabs-container').removeClass('u-dn');
		if (window.location.href.indexOf('shop') !== -1) {
			$('.pusher').children().each(function () {
				$(this).removeClass('u-dn');
			});
		}
	}
}

export default {
	setPageActive
};



// WEBPACK FOOTER //
// ./mobile-core/src/about.js